import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/Yard/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_yard } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_yard(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listYardMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Yard'}
            >
                <Form
                    title={'Add Yard'}
                    onSubmit={onSubmit}
                    buttonName={'Create Yard'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add